<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('account.addAccount') }}
      </div>
    </div>
    <div class="wrap_box warp1 bgdeep">
      <div class="item">
        <div class="ari_font">
          <!-- {{$t('invest_bank.bank')}} -->
          {{ $t('account.bank') }}
        </div>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="value"
            :options="wallets"
            @change="onChange()"
          />
        </van-dropdown-menu>
      </div>
      <!-- 虚拟货币 -->
      <div v-show="bank.type == 1">
        <div class="item">
          <div class="ari_font">
            {{ $t('account.address') }}：
          </div>
          <input
            v-model="bank.account"
            class="card"
            type="text"
            :placeholder="$t('account.addressTit')"
          >
        </div>
        <!-- <div class="qrcode">
					<div>{{$t('account.qrcodetips')}}</div>
					<div class="qrcode_img">
						<van-uploader v-model="fileList" multiple :max-count="1" class="upload" :max-size="2 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead"
							:before-read="beforeRead">
						</van-uploader>
					</div>
				</div> -->
      </div>
      <!-- 银行卡 -->
      <div v-show="bank.type == 4">
        <div class="list_wrap">
          <div class="listItem">
            <div class="label">
              {{ $t('invest_bank.bank') }}
            </div>
            <input
              v-model="bank.area"
              class="inputView"
              type="text"
              :placeholder="$t('invest_bank.bankin')"
            >
          </div>
          <div class="listItem">
            <div class="label">
              {{ $t('invest_bank.name') }}
            </div>
            <input
              v-model="bank.name"
              class="inputView"
              type="text"
              :placeholder="$t('invest_bank.namein')"
            >
          </div>
          <div class="listItem">
            <div class="label">
              {{ $t('invest_bank.account') }}
            </div>
            <input
              v-model="bank.account"
              class="inputView"
              type="text"
              :placeholder="$t('invest_bank.accountin')"
            >
          </div>
        </div>
        <!-- <div class="item">
					<div class="ari_font">{{$t('invest_bank.name')}}</div>
					<input class="card" type="text" v-model="bank.name" :placeholder="$t('invest_bank.namein')">
				</div>
				<div class="item">
					<div class="ari_font">{{$t('invest_bank.account')}}</div>
					<input class="card" type="text" v-model="bank.account" :placeholder="$t('invest_bank.accountin')">
				</div>
				<div class="item">
					<div class="ari_font">{{$t('invest_bank.bank')}}</div>
					<input class="card" type="text" v-model="bank.area" :placeholder="$t('invest_bank.bankin')">
				</div> -->
      </div>
    </div>
    <div
      class="basic_btn warp1"
      @click="submitBtn"
    >
      {{ $t('account.submit') }}
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import {
        Overlay,Uploader,Button,DropdownMenu, DropdownItem,Toast
    } from 'vant';
    import axios from 'axios'

    Vue.use(Overlay).use(Uploader).use(Button).use(DropdownMenu).use(DropdownItem);
    export default {
        name: "AddcountUsdt",
        data() {
            return {
                bank: {
                    account: '',
					name:'',
                    area: '',
                    bank:'',
					img:'',
					type:1,
					wid:0
                },
				fileList: [],
				type:1,
				value:0,
				wallets:[]
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
			start(){
				Fetch('/user/wallet_type',{
				}).then(r=>{
					this.bank.bank = r.data[0].name;
					this.bank.type = r.data[0].type;
					this.bank.wid = r.data[0].id;
					for (let i = 0; i < r.data.length; i++) {
						this.wallets.push({
						    text: r.data[i].name,
						    value: i,
							type:r.data[i].type,
							wid:r.data[i].id
						})
					}
				})
			},
            submitBtn(){
				// if (!this.bank.card) {
				//     this.$notify(this.$t('account.addressEmpty'));
				//     return;
				// }
				// if (!this.bank.img) {
				//     this.$notify(this.$t('account.qrcodeEmpty'));
				//     return;
				// }
                Fetch('/user/bank_add',{
                    ...this.bank
                }).then(r=>{
					this.$router.go(-1);
                })
            },
			onOversize(file) {
			    this.$toast(this.$t('account.within2megabytes'));
			},
			beforeRead(file) {
			    if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
			        this.$toast(this.$t('account.supportPicture'));
			        return false;
			    }
			    return true;
			},
			afterRead(file) {
			    let formData = new FormData();
				formData.append('language', this.$i18n.locale||"zh_cn");
			    formData.append('file', file.file);
			    formData.append('id', this.$router.history.current.params.id);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
			    axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.bank.img = r.data.data;
			        } else {
			            if (r.data.info) {
			                this.$toast(r.data.info);
			            } else {
			                this.$toast(this.$t('account.uploadFail'));
			            }
			        }
			    });
			},
			onChange(){
				this.type = this.wallets[this.value]['type'];
				this.bank.bank = this.wallets[this.value]['text'];
				this.bank.type = this.wallets[this.value]['type'];
				this.bank.wid = this.wallets[this.value]['wid'];
				// console.log(this.wallets)
			}
            
        }
    };
</script>

<style lang="less" scoped>
	// /deep/ .van-overlay{
	// 	background-color:hsla(0,0%,100%,0);
	// }
 //    /deep/ .van-dropdown-menu {
 //        position: relative;
	// 	width: 100%;
 //        z-index: 10;
 //        color: #CCCCCC;
 //    }

    /deep/ .van-dropdown-menu__bar {
		box-shadow:none;
        // position: relative;
        // z-index: 10;
        // height: 34px;
        // border: 1px solid #D9D9D9;
        // border-radius: 4px;
        // text-align: left;
    }
 //    /deep/ .van-dropdown-item--down {
 //        margin: 0 auto;
 //        z-index: 12;
 //        transform: translateX(4px);
 //    }

    // /deep/ .van-dropdown-menu__item {
    //     justify-content: flex-start;
    //     color: #ccc;
    //     background-color: #fff;
    // }

 //    /deep/ .van-dropdown-menu__title {
 //        width: 100%;
 //    }

 //    /deep/ .van-dropdown-menu__title::after {
 //        width: 13px;
 //        height: 22px;
 //        transform: none;
 //        background: url(../../assets/images/drop.png) no-repeat center center;
 //        background-size: 100% 100%;
 //        border: none;
 //        opacity: 1;
 //        margin-top: -11px;
 //        right: 10px;
 //    }

 //    /deep/ .van-cell {
 //        padding: 5px 8px;
 //    }

 //    /deep/ .van-cell__title {
 //        flex: 3;
 //        white-space: normal;
 //    }

 //    /deep/ .van-ellipsis {
 //        color: #000;
 //    }

 //    /deep/ .van-dropdown-item__option {
 //        color: #ccc;
 //        border: 1px solid #D9D9D9;
 //        border-bottom: none;
 //        border-radius: 4px;
 //    }

 //    /deep/ .van-dropdown-item__option:last-child {
 //        border-bottom: 1px solid #D9D9D9;
 //    }

 //    /deep/ .van-dropdown-item__option--active.van-dropdown-item__option {
 //        color: #000;

 //        .van-dropdown-item__icon {
 //            color: #E96259;
 //        }
 //    }
	/deep/ .van-button--primary {
	    background-color: transparent;
	    border: none;
	    width: 100%;
		height: 100%;
	}
	/deep/ .van-uploader__input-wrapper {
	    width: 100%;
	}
	/deep/ .van-uploader__wrapper{
		width: 100%;
		height: 100%;
	}
	/deep/ .van-uploader__upload{
		width: 100%;
		height: 100%;
		margin:0;
	}
	/deep/ .van-uploader__preview{
		margin:0;
	}
	/deep/ .van-uploader__preview-image{
		width: 100%;
		height: 100%;
	}
	
    .rela {
        position: relative;
        z-index: 11;
    }

    .warp1 {
		margin: 10px;
        margin-top: 12px;
		background-color: #fff;
		padding-bottom: 10px;
        .item {
            height: 50px;
            padding: 0 16px;
            font-size: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }
			.card{
				width: 100%;
			}
            input {
                line-height: 14px;
            }
        }
    }

    .ari_font {
        word-break: keep-all;
        white-space: nowrap;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        // color: rgba(0,0,0,.8);
        line-height: 20px;
		margin-right: 10px;
    }

    .basic_btn {
		margin: 30px auto 0 auto;
		width: 95%;
		height: 50px;
		line-height: 50px;
    }
	.qrcode{
		padding-top: 30px;
		padding-bottom: 30px;
		text-align: center;
		div{
			color: #999;
			font-size: 14px;
			margin-bottom: 20px;
		}
		.upload{
			width: 100%;
			height: 100%;
		}
		.qrcode_img{
			width: 250px;
			height: 250px;
			margin: 0 auto;
			background: linear-gradient(to left, #999, #999) left top no-repeat, 
						linear-gradient(to bottom, #999, #999) left top no-repeat, 
						linear-gradient(to left, #999, #999) right top no-repeat,
						linear-gradient(to bottom, #999, #999) right top no-repeat, 
						linear-gradient(to left, #999, #999) left bottom no-repeat,
						linear-gradient(to bottom, #999, #999) left bottom no-repeat,
						linear-gradient(to left, #999, #999) right bottom no-repeat,
						linear-gradient(to left, #999, #999) right bottom no-repeat;
			background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px; 
			span{
				line-height: 220px;
			}
			img{
				width: 240px;
				height: 240px;
				position: relative;
				top: -255px;
			}
		}
	}
	::placeholder {
		color: #727d91 !important; /* 设置你想要的颜色 */
	}
	
	/deep/ .van-dropdown-menu__title::after {
	    width: 8px;
	    height: 8px;
	    border-color: transparent transparent #727d91 #727d91;
		right: -18px;
		margin-top: -10px;
	}
	/deep/ .van-dropdown-menu__title--down::after {
		margin-top: -1px !important;
		-webkit-transform: rotate(135deg);
		transform: rotate(135deg);
	}
	/deep/ .van-dropdown-menu__bar{
		background-color: transparent;
	}
	/deep/ .van-dropdown-item--down{
		margin: 0 10px;
	}
	/deep/ .van-dropdown-item__option--active{
		color: #fff;
	}
	/deep/ .van-dropdown-item__option--active .van-dropdown-item__icon{
		color: #fff;
	}
	/deep/ .van-cell{
		background-color: #9aa0a9;
		// background: linear-gradient(90deg, #eae5c9, #a0f1ea) !important;
	}
	/deep/ .van-popup--top{
		
		border-radius: 0vw 0vw 2vw 2vw;
	}
	.item input {
	    color: #282828;
	}
	
	.list_wrap{
	    padding: 0 10px;
		.listItem {
		    display: flex;
		    flex-direction: column;
		}
		.label{
		    height: 44px;
		    display: flex;
		    align-items: center;
		    font-size: 13px;
		    font-weight: 400;
		    color: #333;
		}
		.inputView{
		    height: 50px;
		    border-radius: 10px;
		    border: 1px solid #c4c4c6;
		    padding-left: 11px;
		}
	}

	/* Ivory, champagne-gold and rose-wine account form theme. */
	.recharge_wrap { min-height: 100vh; padding-bottom: calc(86px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); color: #533126; }
	.red_top_bg { height: 54px; background: rgba(255, 252, 245, .97); border-bottom: 1px solid rgba(190, 139, 52, .45); }.red_top_bg .big_tit, .red_top_bg .back_left { color: #8f251d; }
	.warp1 { margin: 16px 14px 0; padding: 0 14px 12px; border: 1px solid rgba(190, 139, 52, .52); border-radius: 15px; background: rgba(255, 254, 249, .95); box-shadow: 0 9px 18px rgba(126, 84, 29, .09); }.warp1 .item { border-bottom-color: rgba(190, 139, 52, .24); }.ari_font, .list_wrap .label { color: #533126; }.item input, .list_wrap .inputView { border-color: rgba(190, 139, 52, .48); background: #fffdf8; color: #533126; }.warp1 .item .card { height: 36px; min-width: 0; padding: 0 10px; border: 1px solid rgba(190, 139, 52, .42); border-radius: 7px; box-sizing: border-box; font-size: 14px; line-height: 34px; }.list_wrap .inputView { border-radius: 9px; }.item input::placeholder, .list_wrap .inputView::placeholder { color: #9c8068 !important; }
	.basic_btn.warp1 { width: calc(100% - 28px); height: 48px; margin: 24px 14px 0; padding: 0; border: 1px solid #b9802e; border-radius: 12px; background: linear-gradient(105deg, #a6233d, #ca5a5b) !important; color: #fff9ea !important; line-height: 46px; box-shadow: 0 9px 20px rgba(151, 17, 56, .18); }
	/deep/ .van-dropdown-menu__bar { height: 40px; background: transparent; }.warp1 /deep/ .van-dropdown-menu__title { color: #8f251d; }.warp1 /deep/ .van-dropdown-menu__title::after { border-color: transparent transparent #b9802e #b9802e; }.warp1 /deep/ .van-dropdown-item__content { background: #fffdf8; }.warp1 /deep/ .van-cell { background: #fffdf8; color: #533126; }.warp1 /deep/ .van-dropdown-item__option--active, .warp1 /deep/ .van-dropdown-item__option--active .van-dropdown-item__icon { color: #a6233d; }

	/* Wallet form uses the user-center card, field, and teal action hierarchy. */
	.recharge_wrap { background: linear-gradient(180deg, #f3f9f8, #ebf5f3); color: #123d42; }
	.red_top_bg { border-bottom-color: #c7e0dd; background: rgba(255, 255, 255, .97); box-shadow: 0 4px 14px rgba(10, 73, 79, .07); }.red_top_bg .big_tit, .red_top_bg .back_left { color: #073f47; }
	.warp1 { border-color: #c9e1de; border-radius: 16px; background: rgba(255, 255, 255, .95); box-shadow: 0 9px 18px rgba(12, 75, 79, .09); }.warp1 .item { border-bottom-color: #deebea; }.ari_font, .list_wrap .label { color: #173f44; }.item input, .list_wrap .inputView { border-color: #c7e0dd; background: #f4fbfa; color: #123d42; }.item input::placeholder, .list_wrap .inputView::placeholder { color: #71898b !important; }
	.basic_btn.warp1 { border-color: #0c7b83; background: #073f47 !important; color: #fff !important; box-shadow: 0 9px 20px rgba(11, 70, 76, .18); }
	.warp1 /deep/ .van-dropdown-menu__title { color: #075963; }.warp1 /deep/ .van-dropdown-menu__title::after { border-color: transparent transparent #0d8d94 #0d8d94; }.warp1 /deep/ .van-dropdown-item__content, .warp1 /deep/ .van-cell { background: #fff; color: #123d42; }.warp1 /deep/ .van-dropdown-item__option--active, .warp1 /deep/ .van-dropdown-item__option--active .van-dropdown-item__icon { color: #08646d; }
</style>
